__turbopack_context__.v({
  "reviewsRating": "product-parameters-module-scss-module__2npaNG__reviewsRating",
  "stickyPannel": "product-parameters-module-scss-module__2npaNG__stickyPannel",
  "subInfoPanel": "product-parameters-module-scss-module__2npaNG__subInfoPanel",
  "subInfoPanelItem": "product-parameters-module-scss-module__2npaNG__subInfoPanelItem",
});
